module.exports = __webpack_public_path__ + "static/media/newsCarousel.0f3fce0e.png";